import type { CategoryPrompt } from "@v2/features/home/components/prompt-suggestions/types";

import React from "react";

import { HorizontalCarousel } from "@v2/components/carousel/HorizontalCarousel";
import { motion } from "motion/react";

export function PromptCarousel({
  prompts,
  onSelectPrompt,
}: {
  prompts: CategoryPrompt[];
  onSelectPrompt: (prompt: string, action?: "upload") => void;
}) {
  return (
    <div className="relative z-[1]">
      <HorizontalCarousel listenerDelay={350} gap="3" UNSAFE_className="pb-2">
        {prompts.map((prompt, index) => (
          <motion.button
            key={prompt.title}
            initial={{ opacity: 0, scale: 0.9, y: -10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.2, delay: index * 0.05 }}
            onClick={() => {
              onSelectPrompt(
                prompt.prompt,
                prompt.action === "upload" ? "upload" : undefined,
              );
            }}
            className="w-48 md:w-[calc((100%-24px)/3)] bg-white border-0.5 border-border rounded-xl p-3 md:p-4 flex flex-col gap-2 items-start text-left hover:bg-sheet transition-colors flex-none snap-start cursor-pointer"
          >
            <div className="w-6 h-6 md:w-8 md:h-8 bg-sheet border border-border rounded-md flex items-center justify-center text-default">
              {React.cloneElement(prompt.icon, {
                className: "w-3 h-3 md:w-4 md:h-4",
              })}
            </div>
            <div className="flex flex-col gap-0.5 w-full">
              <div className="text-xs md:text-sm header-h6">{prompt.title}</div>
              <div className="text-xs md:text-sm text-muted">
                {prompt.description}
              </div>
            </div>
          </motion.button>
        ))}
      </HorizontalCarousel>
    </div>
  );
}
